import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import { printdDate } from '../helper.js';
import View from './View';

class aboutView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'About View Error Message';
  _message = 'About View Success Message';

  _generateMarkup() {
    return `
             <div class="row about">
        <h1 class="heading__static">About Us</h1>
        <p class="paragraph">
          Pragya Enterprises is a partnership venture that is providing its
          service in delivering attires specialy in education sectors. We are
          providing our expertised excellent service since 1981 in the industry.
          Till now we have sold more than ten thousand school uniforms.
        </p>

        <p class="paragraph">
          Our vision behind the creative initiative in the industry is to allow
          more personalisational and customisational appproach for tailoring
          uniforms as per requirent and need from school as well as student.
        </p>
        <p class="paragraph">
          Pragya Enterprises is working to achieve its goal since 1981. During
          this journey, we have worked with many enthusiastic educational
          institutions to attire the students.
        </p>
        <p class="paragraph">
          Pragya Enterprises is a clothing store specializing in crafting school
          uniforms as per customer/school/students needs. We offer Customized
          school uniforms as per school requirements to our customers, ensuring
          bulk and fast delivery of finished product with competitive pricing
          and excellent customer support.
        </p>
        <p class="paragraph">
          Here providing specialized and customized school uniform as per
          requirement to the institutions/students/scholars/teachers or any
          sound mind people who are interested, is our prime objective by
          selling them as a product at onetime payment on our website
          pragya.enterprises.
        </p>
      </div>
       
    `;
  }
}

export default new aboutView();
